import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ScreenSwitchWrapperBaseComponent, SharedService,WhitelabelState } from '@moduurnv2/libs-orderingapp/src';
import { Store } from '@ngxs/store';

@Component({
  selector: 'moduurnv2-organization-locations-wrapper',
  templateUrl: './organization-locations-wrapper.component.html',
})
export class OrganizationLocationsWrapperComponent extends ScreenSwitchWrapperBaseComponent {
  constructor(shared:SharedService, store:Store ,private title:Title, private meta: Meta){
    super(shared,store);
  }
}
